import {CommandActionListItem, ScopedCommands} from '@github-ui/ui-commands'
import {KebabHorizontalIcon, QuoteIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface ConversationItemActions {
  onQuoteReply?: () => void
}

export function ConversationItemActions({onQuoteReply}: ConversationItemActions) {
  return onQuoteReply ? (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={KebabHorizontalIcon} variant="invisible" size="small" aria-label="More actions" />
      </ActionMenu.Anchor>

      <ActionMenu.Overlay align="end">
        <ActionList>
          <CommandActionListItem
            commandId="pull-requests:quote-reply"
            onSelect={onQuoteReply}
            leadingVisual={<QuoteIcon />}
          >
            Quote reply
          </CommandActionListItem>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  ) : undefined
}

export function ConversationItemActionsProvider({
  onQuoteReply,
  children,
}: React.PropsWithChildren<ConversationItemActions>) {
  return <ScopedCommands commands={{'pull-requests:quote-reply': onQuoteReply}}>{children}</ScopedCommands>
}
